<template lang="html">
  <section class="tour-info">

      <div class="ti__img">
        <div class="ti-img__static">
          <span></span>
          <span></span>
          <img :src="image" alt="">
        </div>
        <div class="ti-img__floater">
          <img :src="image" alt="">
        </div>
      </div>

      <div class="ti__cap">
        <div>
          <span class="notch notch--sm notch--red"></span>
          <p>
            <slot>No data has been entered for this slot.</slot>
          </p>
        </div>
      </div>

    </section>
</template>

<script>
  export default {
    name: 'tour-info',
    props: {
      image: String
    },
    data () {
      return {

      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .tour-info {
    margin-bottom: 4rem;
    @include breakpoint($md) {
      display: grid;
      grid-template-rows: auto;
      margin-bottom: 11rem;

      // Even rows of images
      &:nth-of-type(even) {
        grid-template-columns: 40% 60%;
        .ti__img {
          order: 2;
        }

        .ti-img__floater {
          left: 0;
          width: calc(100% - 50px);
          img {
            width: 100%;
            height: auto;
            object-fit: fill;
          }
        }

        .ti-img__static {
          span:nth-child(1) {
            right: 0;
          }

          span:nth-child(2) {
            right: 0;
          }

          img {
            margin-left: 50px;
            width: calc(100% - 50px;)
          }
        }

        .ti__cap {
          order: 1;
        }
      }

      // Odd rows of images
      &:nth-of-type(odd) {
        grid-template-columns: 60% 40%;
        .ti__img {
          order: 1;
        }

        .ti-img__floater {
          right: 0;
          width: calc(100% - 50px);
        }

        .ti-img__static {
          span:nth-child(1) {
            left: 0;
          }

          span:nth-child(2) {
            left: 0;
          }

          img {
            margin-right: 50px;
            width: calc(100% - 50px;)
          }
        }
      }
    }
  }

  .ti__img {
    position: relative;
    @include breakpoint($md) {
      grid-row: 1 / 2;
    }
  }

  .ti-img__static {
    position: relative;
    span {
      position: absolute;
      z-index: 10;
    }
    span:nth-child(1) {
      top: 0;
      width: 100px;
      height: 50px;
      background-color: rgba($light-blue, 0.6);
    }
    span:nth-child(2) {
      width: 100%;
      height: 50px;
      bottom: 0px;
      background-color: rgba($light-red, 0.6);
      @include breakpoint($md) {
        top: 50px;
        width: calc(100% - 50px);
        height: calc(100% - 50px);
      }
    }
    img {
      width: 100%;
      height: auto;
      vertical-align: middle;
      object-fit: fill;
      @include breakpoint($md) {
        width: calc(100% - 50px);
      }
    }
  }

  .ti-img__floater {
    display: none;
    img {
      width: 100%;
      height: auto;
      vertical-align: middle;
      object-fit: fill;
    }
    @include breakpoint($md) {
      display: block;
      position: absolute;
      top: -50px;
      z-index: 20;
    }
  }

  .ti__cap {
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      padding: 2rem 1rem;
    }
    @include breakpoint($md) {
      grid-row: 1 / 2;
      order: 2;
      > div {
        max-width: 360px;
        padding: 0 0.5rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TourInfo.vue